import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useDidMount, useNavigateWithId } from '../customHooks';

const TopicPath = function () {
  const reserveChange = useSelector((state) => state.reserveChange);

  const lgCd = useSelector((state) => state.reserve.lgCd);
  const rsvConfig = useSelector((state) => state.rsvConfig);
  const { topicPath = [] } = rsvConfig;
  const businessChangeMode = useSelector((state) => state.reserveChange.businessChangeMode);
  const businessChanged = useSelector((state) => state.reserveChange.businessChanged);

  const navigate = useNavigateWithId();
  const location = useLocation();

  // 現在閲覧中のページのパス
  const locationPath = window.location.pathname;
  // const currentPath = locationPath.substring(locationPath.lastIndexOf('/') + 1);
  // const currentPath = locationPath.replace('/reserve/', '');
  const tmpPath1 = locationPath.replace('/reserve/', '');
  const tmpPath2 = tmpPath1.replace('/test', '');
  const currentPath = tmpPath2.replace('/demo', '');

  const [topicPathList, setTopicPathList] = useState([]);
  const [displayFlag, setDisplayFlag] = useState(false);

  // ページ遷移処理（現在ページの state を引き継いで遷移先のクラッシュを防ぐ）
  const moveToUrl = (url) => {
    navigate(`/${url}`, { state: location.state });
  };

  // パンくずリストの作成
  const createTopicPath = async () => {
    const topicPathList = [];
    let activeFlag = true;
    for (let i = 0; i < topicPath.length; i += 1) {
      const { url = '', scnName = '' } = topicPath[i];
      // businessChangeMode===1 で用件を変更しなかった場合、予約者情報の変更はスキップ
      if (businessChangeMode === 1 && !businessChanged && url === 'change/userinfo') {
        continue;
      }
      if (url === '/:lgCd') {
        // TOPページへのパンくず
        topicPathList.push(
          <li className="top">
            <a
              role="button"
              // href="javascript:void(0);"
              onClick={() => moveToUrl(`${lgCd}`)}
              tabIndex={0}
            >
              {scnName}
            </a>
          </li>
        );
      } else if (url === 'change/:url') {
        topicPathList.push(
          <li className="top">
            <a
              role="button"
              // href="javascript:void(0);"
              onClick={() => {
                moveToUrl(`change/${reserveChange.url}`);
              }}
              tabIndex={0}
            >
              {scnName}
            </a>
          </li>
        );
      } else if (currentPath === url) {
        topicPathList.push(<li className="current">{scnName}</li>);
        activeFlag = false;
      } else if (activeFlag === false || currentPath === 'cmplt') {
        topicPathList.push(<li>{scnName}</li>);
      } else {
        // 遷移可能なページ（現在より前のページ）
        topicPathList.push(
          <li>
            <a
              role="button"
              // href="javascript:void(0);"
              onClick={() => moveToUrl(url)}
              tabIndex={0}
            >
              {scnName}
            </a>
          </li>
        );
      }
    }

    setTopicPathList([...topicPathList]);
  };

  useDidMount(() => {
    createTopicPath();

    // パンくずリストを表示するかの設定
    const check1 = topicPath.findIndex((value) => value.url === currentPath) !== -1;
    const check2 = currentPath === 'cmplt';

    if (check1 || check2) {
      setDisplayFlag(true);
    }
  });

  return (
    <div id="topicpath">{displayFlag ? <ul className="row inline">{topicPathList}</ul> : null}</div>
  );
};

export default TopicPath;
